export const YourMainCompetitorsCss = {
  scorePerSx: {
    fontFamily: 'Inter',
    fontWeight: '500',
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'right',
    color: 'var(--color-text-muted)'
  },
  siteIconBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  }
};
